var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fix-layout app-container"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"body"},[_vm._t("default")],2),_c('div',{staticClass:"footer fix-footer save"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }